import Tag from "components/Common/Tag/Tag";
import { useTitleSuggester } from "hooks/useTitleSuggester";
import React, { useEffect } from "react";
import starsicon from "../../images/stars.svg";
import { FaSync, FaPlus } from "react-icons/fa";
const FaSyncSin = FaSync as unknown as React.FC as any;
// interface TitleSuggesterProps {
//   jobTitles: string[];
//   skills: string[];
// }

// const TitleSuggester: React.FC<TitleSuggesterProps> = ({ jobTitles, skills }) => {
//   const { titles, loading, error, fetchTitles, refreshTitles } = useTitleSuggester();

//   useEffect(() => {
//     fetchTitles(jobTitles, skills);
//   }, [jobTitles, skills, fetchTitles]);

//   return (
//     <div className="mb-4">
//       <h2 className="text-sm font-normal mb-2 flex gap-2 justify-start items-center text-text-quaternary">
//         <img className="relative" src={starsicon} alt="Stars Icon" /> Recommended Titles:
//       </h2>
//       {loading ? (
//         <p>Loading...</p>
//       ) : error ? (
//         <p>Error: {error.message}</p>
//       ) : (
//         <div className="flex flex-wrap gap-2">
//           {titles?.map((title, index) => (
//             <span key={index} className="flex items-center">
//               <Tag title={title} suffixIcon={<FaPlus className="mr-1" />} tagType="primary" />
//             </span>
//           ))}
//           <button onClick={refreshTitles} className="flex items-center justify-center">
//             <Tag title="Refresh" prefixIcon={<FaSync className="mr-1" />} tagType="secondary" />
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TitleSuggester;

import { useKeywordSuggester } from "hooks/useKeywordSuggester";
import CustomTagWithPlus from "components/Common/Tag/CustomTagWithPlus";
import { CloseOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useAppSelector } from "hooks/reduxHooks";
import { SvgIcons } from "Icon/SvgIcons";

interface JobTitleSuggesterProps {
  jobTitles: string[];
  isSectionTitleRequired: boolean;
  sectionTitle?: string;
  handleAdd?: (value: string) => void;
  selectedValues?: string[];
  onClearAll?: () => void;
}

const TitleSuggester: React.FC<JobTitleSuggesterProps> = ({
  jobTitles,
  isSectionTitleRequired,
  sectionTitle,
  handleAdd,
  selectedValues = [], // Default to an empty array if not provided
  onClearAll,
}) => {
  const { suggestedJobTitles, loading, refreshLoading, error, fetchKeywords, refreshKeywords } =
    useKeywordSuggester();
  const selectedProject = useAppSelector((state: any) => state.search?.selectedProjectFromSearch);

  useEffect(() => {
    if (jobTitles.length > 0) {
      console.log("Job Title : ", jobTitles);
      fetchKeywords(jobTitles);
    } else {
      console.log("Job Title in project : ", selectedProject);
      fetchKeywords(selectedProject?.official_title);
    }
  }, [jobTitles]);

  return (
    <div className="mb-4">
      {isSectionTitleRequired ? (
        <h2 className="text-sm font-normal mb-2 flex gap-2 justify-start items-center text-text-quaternary">
          <img className="relative" src={starsicon} alt="Stars Icon" /> {sectionTitle}:
        </h2>
      ) : (
        ""
      )}
      <div className="flex flex-wrap gap-2">
        {loading ? (
          <Spin spinning={loading} size="small" />
        ) : error ? (
          // <p>Error: {error.message}</p>
          <></>
        ) : (
          <>
            {suggestedJobTitles?.map((title, index) => {
              const isSelected = selectedValues.includes(title);
              return (
                <React.Fragment key={index}>
                  <CustomTagWithPlus
                    value={title}
                    isSelected={isSelected}
                    handleClick={handleAdd}
                  />
                </React.Fragment>
              );
            })}
            {/* <button
          onClick={refreshKeywords} 
          className="flex items-center justify-center button-hover-effect text-sm"
          >
            {refreshLoading ? (
              <Spin spinning={refreshLoading} size="small" className="mr-1" />
            ) : (
              <>
                {keywords?.map((keyword, index) => {
                  const isSelected = selectedValues.includes(keyword);
                  return (
                    <React.Fragment key={index}>
                      <CustomTagWithPlus
                        value={keyword}
                        isSelected={isSelected}
                        handleClick={handleAdd}
                      />
                    </React.Fragment>
                  );
                })
                } */}
            <button
              onClick={refreshKeywords}
              className="flex items-center justify-center button-hover-effect text-xs 
              font-medium text-text-secondary py-0.5 px-2 border bg-bg-secondary  border-main-border gap-1
              rounded-md"
            >
              {refreshLoading ? (
                <Spin spinning={refreshLoading} size="small" />
              ) : (
                <>
                  {SvgIcons.primaryRefreshIcon}
                </>
              )}
              &nbsp;Refresh
            </button>
            {jobTitles.length > 0 && (
              <button
                onClick={onClearAll}
                className="flex items-center justify-center
                 py-0.5 px-2 border bg-red-50
                 border-red-200 gap-2 rounded-md
                focus:outline-none focus:ring-none text-sm"
              >
                <Tag
                  title="Clear All"
                  prefixIcon={<CloseOutlined size={12} className="mr-1" style={{ color: "red" }} />}
                  tagType="secondary"
                  titleColor="text-red-500 hover:text-red-700"
                  className="transition 
                  duration-300 ease-in-out text-xs font-medium"
                />
              </button>
            )}
          </>
        )}
      </div>
      {/* )} */}
    </div>
  );
};

export default TitleSuggester;
